<template>
  <div class="settings scrollbar settings-authenticator">
    <div class="settings-header">
      <button type="button" class="history-back" @click="previous">
        <arrow-left-icon></arrow-left-icon>
      </button>
      Authenticator settings

    </div>

    <div v-if="!offlineMode&&templateId">
      <!--Only show when templateId available-->

      <hr class="settings-divider"/>

      <button type="button" class="block"  @click.once="refreshAuthenticators" :disabled="fetching">
        <reload-icon></reload-icon>
        <span class="settings-text">
        Reload authenticators
      </span>
      </button>

    </div>

    <hr class="settings-divider"/>

    <div class="settings-body">

      <form v-on:submit.prevent="post(form)">

        <div class="form-group pb-2">
          <div class="custom-control custom-checkbox float-right">
            <input type="checkbox" class="custom-control-input" id="advanced_template"
                   v-model="form.advancedTemplate" @change="post(form)" :disabled="offlineMode">
            <label class="custom-control-label"
                   for="advanced_template">Manual input</label>
          </div>
          <label for="template_id">Authenticator template</label>
          <Select2 v-if="!form.advancedTemplate" id="template_id" v-model="form.templateId"
                   :options="possibleAuthenticatorTemplates" :disabled="offlineMode"
                   :settings="{}" @change="post(form)"/>


          <input v-if="form.advancedTemplate" type="number" min="0" step="1" class="form-control"
                 id="template_id"
                 :disabled="offlineMode" v-model="form.templateId" @change="post(form)">


          <small> Need help
            <a href="#" @click="showHelp" class="d-inline p-0">how to configure secret
              server</a>
            ?
          </small>
        </div>

        <div class="form-group pb-2">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="show_otp" v-model="form.show"
                   @change="post(form)">
            <label class="custom-control-label"
                   for="show_otp">Always show One Time Passwords</label>
          </div>
        </div>

        <a v-if="!showAdvanced&&!form.advancedTemplate" href="#" @click="toggleShowAdvanced">Show advanced template
          configuration</a>
        <a v-if="showAdvanced&&!form.advancedTemplate" href="#"
           @click="toggleShowAdvanced">Hide advanced template configuration</a>

        <div class="card-body border" v-if="showAdvanced&&!form.advancedTemplate">


          <a href="#" class="btn btn-sm btn-link float-right ml-2" @click="resetTemplateFilter">Reset
            to default</a>
          <p>Terms used to match possible authenticator secret templates:</p>
          <div class="input-group mb-2">
            <input type="text" class="form-control" @keyup.enter.prevent="postTemplateFilter"
                   v-model="form.newTemplateFilter">
            <div class="input-group-append">
              <button class="btn btn-outline-secondary" type="button" @click="postTemplateFilter">
                Add term
              </button>
            </div>
          </div>
          <ul class="list-group list-group-flush mb-5">
            <li v-for="(option, i) in filterTemplateOn" class="list-group-item px-0">
              {{option}} <a @click="removeTemplateFilter(i)" class="btn-link float-right"
                            href="#">remove</a>
            </li>
          </ul>
          <span v-if="!filterTemplateOn" class="alert alert-danger">No terms defined - requires at least one term in order to function</span>

          <a href="#" class="btn btn-sm btn-link float-right ml-2" @click="resetFieldFilter">Reset to
            default</a>
          <p>Terms used to match the secret's field which is used to generate the One Time
            Passwords.</p>

          <div class="input-group mb-2">
            <input type="text" class="form-control" @keyup.enter.prevent="postFieldFilter"
                   v-model="form.newFieldFilter">
            <div class="input-group-append">
              <button class="btn btn-outline-secondary" type="button" @click="postFieldFilter">
                Add term
              </button>
            </div>
          </div>
          <ul class="list-group list-group-flush">
            <li v-for="(option, i) in filterFieldOn" class="list-group-item px-0">
              {{option}} <a @click="removeFieldFilter(i)" class="btn-link float-right" href="#">remove</a>
            </li>

          </ul>
          <span v-if="!filterFieldOn" class="alert alert-danger">No terms defined - requires at least one term in order to function</span>

        </div>

      </form>
    </div>
  </div>

</template>

<script>
  import EventHub from '@/events/event-hub';
  import _ from 'lodash';
  import {mapActions, mapGetters} from 'vuex';

  import * as Toastr from 'toastr';
  import Select2 from 'v-select2-component';

  import DeleteIcon from "vue-material-design-icons/Delete";
  import ReloadIcon from "vue-material-design-icons/Reload";
  import DownloadIcon from "vue-material-design-icons/Download";
  import UploadIcon from "vue-material-design-icons/Upload";
  import ArrowLeftIcon from "vue-material-design-icons/ArrowLeft";

  export default {
    name: 'authenticator-settings',
    components: {
      ArrowLeftIcon,
      UploadIcon,
      DownloadIcon,
      ReloadIcon,
      Select2,
      DeleteIcon
    },
    data() {
      return {
        fetching: false,
        form: {
          fieldId: false,
          templateId: false,
          advancedTemplate: false,
          newTemplateFilter: '',
          filterTemplateOn: [
            "auth",
          ],
          newFieldFilter: '',
          filterFieldOn: [
            "restorecode",
            "authcode",
          ],
        },
        showAdvanced: false,
      };
    },
    computed: {
      ...mapGetters({
        offlineMode: 'auth/offlineMode',
        filterTemplateOn: 'authenticators/filterTemplateOn',
        filterFieldOn: 'authenticators/filterFieldOn',
        secrettemplates: 'secretTemplates/all',
        getTemplateById: 'secretTemplates/getById',
        templateId: 'authenticators/templateId',
        showOtp: 'settings/showOtp',
        okey: 'settings/okey',
        advancedTemplate: 'settings/advancedTemplate',
      }),
      template() {
        if (this.templateId) {
          return this.getTemplateById(this.templateId);
        }
        return false;
      },
      possibleAuthenticatorTemplates() {
        if (this.secrettemplates) {
          return _.filter(this.secrettemplates, template => {
            let name = this.multiIncludes(template.text, this.filterTemplateOn);

            if (name) {
              return true;
            }
          });
        }
        return false;
      },
    },
    methods: {
      ...mapActions({
        addFieldFilter: 'authenticators/addFieldFilter',
        addTemplateFilter: 'authenticators/addTemplateFilter',
        removeFieldFilter: 'authenticators/removeFieldFilter',
        removeTemplateFilter: 'authenticators/removeTemplateFilter',
        resetTemplateFilter: 'authenticators/resetTemplateFilter',
        resetFieldFilter: 'authenticators/resetFieldFilter',
      }),
      multiIncludes(text, values) {
        var re = new RegExp(values.join('|'), 'i');
        return re.test(text);
      },
      showHelp() {
        EventHub.$emit('help-show');
      },
      refreshAuthenticators(e) {
        e.preventDefault();
        this.fetching = true;
        this.$store.dispatch('authenticators/clearAll');
        this.$store.dispatch('asyncData')
          .then(() => {
            return Toastr.success('Authenticators retrieved.');
          })
          .catch(() => {
            return Toastr.error('Unable to fetch authenticators.');
          })
          .finally(() => {
            this.fetching = false;
            this.$router.push({name: 'authenticators'});
          });
      },
      previous() {
        return this.$router.push({name: 'settings'});
      },
      toggleShowAdvanced() {
        this.showAdvanced = !this.showAdvanced;
      },
      postTemplateFilter() {
        if (this.form.newTemplateFilter !== '') {
          this.addTemplateFilter(this.form.newTemplateFilter);
          this.form.newTemplateFilter = '';
        }
      },
      postFieldFilter() {
        if (this.form.newFieldFilter !== '') {
          this.addFieldFilter(this.form.newFieldFilter);
          this.form.newFieldFilter = '';
        }
      },
      deleteOfflineStore() {
        if (confirm("Do you want to remove your offline data?")) { // eslint-disable-line no-alert
          this.form.offline = false;
          this.$store.commit('settings/setOkey', null);
          this.post(this.form);
        }
      },
      post(form) {
        if (!this.offlineMode) {

          if (this.form.templateId) {
            this.$store.commit('authenticators/setTemplateId', this.form.templateId);
          }

          this.$store.commit('settings/setAdvancedTemplate', this.form.advancedTemplate);
          this.$store.commit('settings/setShowOtp', this.form.show);
          Toastr.success('Settings saved');
        }

      },
    },
    mounted() {
      if (this.templateId) {
        this.form.templateId = this.templateId;
      }
      if (this.fieldId) {
        this.form.fieldId = this.fieldId;
      }
      if (this.showOtp) {
        this.form.show = this.showOtp;
      }
      if (this.advancedTemplate) {
        this.form.advancedTemplate = this.advancedTemplate;
      }
      if (this.filterFieldOn) {
        this.form.filterFieldOn = this.filterFieldOn;
      }
      if (!this.offlineMode) {
        this.$store.dispatch('secretTemplates/getSecretTemplates')
          .catch(e => {
            if (e.status == 400 && e.data.errorCode === "API_AccessDenied") {
              this.form.advancedTemplate = true;
            }
          });
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/pages/settings/AuthenticatorSettings.vue